import { Component, OnInit, OnDestroy } from '@angular/core';
import { MilestoneService } from '../../../shared/services/milestone.service';
import {
    IMilestoneEvents,
    IPosition,
    IMilestoneReOrder,
    IChangedData,
} from '../../../shared/interfaces/milestone';
import { State, process, SortDescriptor } from '@progress/kendo-data-query';
import { ToastService } from '../../../shared/services/toast.service';
import { IColumnNames } from '../../../shared/components/dragndrop-table/dragndrop-table.component';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import { CurrentUserStateService } from '../../../shared/services/current-user-state.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatCheckboxChange } from '@angular/material/checkbox';

interface ITabInfo {
    tabIdex: number;
    label: string;
    isSaveDisabled: boolean;
    isCancelDisabled: boolean;
}

@Component({
    selector: 'milestones-events',
    templateUrl: './milestones-events.component.html',
    styleUrls: ['./milestones-events.component.scss'],
})
export class MilestonesEventsComponent implements OnInit, OnDestroy {
    state: State;
    pageable: boolean;
    milestones: IMilestoneEvents[];
    milestonesToSetOrder: IMilestoneEvents[];
    milestonesReodered: IMilestoneEvents[];
    milestonesPrimaryOwner: IMilestoneEvents[];
    milestonesCheckedData: IMilestoneEvents[];
    gridData: any;
    primaryOwnerGridData: any;
    activeTabIndex: number;
    loading = false;
    isAuthorisedUser: boolean;
    resetData = false;
    sort: SortDescriptor[] = [];
    sortable = {
        mode: 'single',
        allowUnsort: false,
    };
    isDataInnitiated: boolean;

    milestoneTabs: ITabInfo[] = [
        {
            tabIdex: 0,
            label: 'Select Milestones',
            isSaveDisabled: true,
            isCancelDisabled: true,
        },
        {
            tabIdex: 1,
            label: 'Order Milestones',
            isSaveDisabled: true,
            isCancelDisabled: true,
        },
        {
            tabIdex: 2,
            label: 'Set Primary Owner per Milestone',
            isSaveDisabled: true,
            isCancelDisabled: true,
        },
    ];
    positionList: IPosition[];

    roleSettings = {
        singleSelection: true,
        text: '',
        selectAllText: '',
        unSelectAllText: '',
        enableSearchFilter: false,
        classes: '',
        badgeShowLimit: 3,
        showCheckbox: false,
        labelKey: 'staffPosition',
        primaryKey: 'staffPositionKey',
    };

    milestoneCheckChangedData: IChangedData[] = [];
    milestoneChangedOwnerdData: IChangedData[] = [];
    columnList: IColumnNames[];

    constructor(
        private _milestoneService: MilestoneService,
        private _toastService: ToastService,
        private _reusableFunctions: ReusableFunctions,
        private _currentUserStateService: CurrentUserStateService
    ) {}

    ngOnInit() {
        this.columnList = [
            {
                columnId: 'milestone',
                columnName: 'Milestone',
                width: 200,
            },
        ];

        let take = 50;
        this.state = {
            skip: 0,
            take: take,
        };

        this.sort = [
            //{ dir: "asc", field: "milestone" },
        ];

        this.loading = true;
        this.isDataInnitiated = false;
        this.isAuthorisedUser =
            this._currentUserStateService.isPowerUser() ||
            this._currentUserStateService.isLBASuperUser(); //TODO: Determine all the autorized users
        this.milestonesReodered = [];
        this.pageable = false;
        this.activeTabIndex = 0;
        this.setButtons(true, true);

        this._milestoneService.getPositionsByClient().subscribe(
            (res) => {
                this.positionList = res;
            },
            (error) => {
                throw new Error(error);
            }
        );

        this._milestoneService.getMilestoneModelsByClient().subscribe(
            (res) => {
                this.milestones = res;
                this.isDataInnitiated = true;
                this.pageable = this.milestones.length > take ? true : false;
                this.setCheckedGridData();
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                throw new Error(error);
            }
        );
    }

    ngOnDestroy() {}

    setCheckedGridData() {
        this.milestonesCheckedData = this.milestones.map((obj) => ({ ...obj }));
        this.milestonesCheckedData.sort((a, b) => a.milestoneOrder - b.milestoneOrder);
        this.gridData = process(this.milestonesCheckedData, this.state);
    }

    setPrimaryOwnerGridData() {
        this.sortPrimaryOwnerGridData();
        this.primaryOwnerGridData = process(this.milestonesPrimaryOwner, this.state);
    }

    sortPrimaryOwnerGridData() {
        this.milestonesPrimaryOwner.sort((a, b) => a.milestoneOrder - b.milestoneOrder);
    }

    updateMilestonesToSetOrder() {
        this.milestonesToSetOrder = this.milestones
            .map((obj) => ({ ...obj }))
            .filter((item) => item.isActive === true && item.allowSorting === true);
        this.milestonesToSetOrder.sort((a, b) => a.milestoneOrder - b.milestoneOrder);
    }

    updateMilestonesToPrimaryOwner() {
        this.milestonesPrimaryOwner = this.milestones
            .map((obj) => ({ ...obj }))
            .filter((item) => item.isActive === true && item.allowSetPrimaryOwner === true);
    }

    setButtons(isSaveDisabled: boolean, isCancelDisabled: boolean) {
        let activeTab = this.milestoneTabs.find((item) => item.tabIdex === this.activeTabIndex);
        activeTab.isCancelDisabled = isCancelDisabled;
        activeTab.isSaveDisabled = isSaveDisabled;
    }

    handleTabChange(event: MatTabChangeEvent): void {
        this.setButtons(true, true);
        this.activeTabIndex = event.index;
        this.milestoneCheckChangedData = [];
        this.milestoneChangedOwnerdData = [];

        if (this.activeTabIndex === 0 && this.isDataInnitiated) {
            this.setCheckedGridData();
        }

        if (this.activeTabIndex === 1) {
            this.updateMilestonesToSetOrder();
        }

        if (this.activeTabIndex === 2) {
            this.updateMilestonesToPrimaryOwner();
            this.setPrimaryOwnerGridData();
        }
    }

    checkBoxToggle(event: MatCheckboxChange, dataItem: IMilestoneEvents) {
        // TODO: Check super user
        this.setButtons(false, false);
        let milestone = this.milestoneCheckChangedData.find(
            (item) => item.milestoneKey === dataItem.milestoneKey
        );
        if (milestone) {
            milestone.isChecked = event.checked;
        } else {
            this.milestoneCheckChangedData.push({
                milestoneKey: dataItem.milestoneKey,
                isChecked: event.checked,
            });
        }
    }

    updateCheckedData() {
        this._milestoneService
            .updateMilestone('IsActive', this.milestoneCheckChangedData)
            .subscribe(
                (res) => {
                    if (res === 1) {
                        this.milestoneCheckChangedData.forEach((checkInf) => {
                            let milestone = this.milestones.find(
                                (item) => item.milestoneKey === checkInf.milestoneKey
                            );
                            if (milestone) {
                                milestone.isActive = checkInf.isChecked;
                            }
                        });

                        this.saveCheckedMilestoneOrderNumber();
                    } else {
                        this._toastService.warning('Some changes were NOT saved!');
                    }
                },
                (error) => {
                    throw new Error(error);
                }
            );
    }

    clickCancel() {
        this.milestoneCheckChangedData = [];
        this.milestoneChangedOwnerdData = [];
        if (this.activeTabIndex === 0) {
            this.setCheckedGridData();
        }

        if (this.activeTabIndex === 1) {
            this.updateMilestonesToSetOrder();
            this.resetData = true;
        }

        if (this.activeTabIndex === 2) {
            this.updateMilestonesToPrimaryOwner();
            this.setPrimaryOwnerGridData();
        }

        this.setButtons(true, true);
    }

    saveChanges() {
        if (this.activeTabIndex === 0) {
            this.updateCheckedData();
        }

        if (this.activeTabIndex === 1) {
            this.saveReorderedMilestones();
        }

        if (this.activeTabIndex === 2) {
            this.updateMilestoneOwner();
        }
    }

    modelChange(event, dataItem: IMilestoneEvents) {
        this.setButtons(false, false);

        let milestone = this.milestoneChangedOwnerdData.find(
            (item) => item.milestoneKey === dataItem.milestoneKey
        );
        if (milestone) {
            milestone.changedValue = event;
        } else {
            this.milestoneChangedOwnerdData.push({
                milestoneKey: dataItem.milestoneKey,
                changedValue: event,
            });
        }
    }

    updateMilestoneOwner() {
        this._milestoneService
            .updateMilestone('ClientStaffPositionKey', this.milestoneChangedOwnerdData)
            .subscribe(
                (res) => {
                    if (res === 1) {
                        this.milestoneChangedOwnerdData.forEach((ownerInf) => {
                            let milestone = this.milestones.find(
                                (item) => item.milestoneKey === ownerInf.milestoneKey
                            );
                            if (milestone) {
                                milestone.staffPositionKey = ownerInf.changedValue;
                            }
                        });
                        this.updateMilestonesToPrimaryOwner();
                        this.setPrimaryOwnerGridData();
                        this.setButtons(true, true);
                        this._toastService.success('Changes were successfully saved!');
                    } else {
                        this._toastService.warning('Changes were NOT saved!');
                    }
                },
                (error) => {
                    throw new Error(error);
                }
            );
    }

    editMilestonesOrder(editedMilestones: IMilestoneEvents[]) {
        this.milestonesReodered = editedMilestones;
        this.resetData = false;
        this.setButtons(false, false);
    }

    saveCheckedMilestoneOrderNumber() {
        let activeMilestones = this.milestones.filter(
            (itm) => itm.isActive === true && itm.allowSorting == true
        );
        let maxOrder = this._reusableFunctions.getMaxValue(activeMilestones, 'milestoneOrder');

        this.milestoneCheckChangedData.forEach((toOrderMilestone) => {
            let milestone = this.milestones.find(
                (itm) => itm.milestoneKey === toOrderMilestone.milestoneKey
            );

            if (milestone) {
                let milestoneOrder =
                    toOrderMilestone.isChecked && milestone.allowSorting
                        ? maxOrder + 1
                        : milestone.milestoneOrder;
                milestone.milestoneOrder = milestoneOrder;
                maxOrder += 1;
            }
        });

        this.updateMilestonesToSetOrder();
        let milestoneReOderedList = this.getSortedMilestoneList(this.milestonesToSetOrder);

        this._milestoneService.saveOrdering(milestoneReOderedList).subscribe(
            (res) => {
                if (res === 1) {
                    this.updateMilestonesToPrimaryOwner();
                    this.setButtons(true, true);
                    this._toastService.success('Changes were successfully saved!');
                } else {
                    this._toastService.warning('Some changes were NOT saved!');
                }
            },
            (error) => {
                throw new Error(error);
            }
        );
    }

    getSortedMilestoneList(sortedMilestones: IMilestoneReOrder[]) {
        let milestoneReOderedList: IMilestoneReOrder[] = [];
        sortedMilestones.forEach((mst, index) => {
            let orderIndex = index + 1;
            milestoneReOderedList.push({
                milestoneKey: mst.milestoneKey,
                milestoneOrder: orderIndex,
            });
        });
        return milestoneReOderedList;
    }

    saveReorderedMilestones() {
        let milestoneReOderedList = this.getSortedMilestoneList(this.milestonesReodered);

        this._milestoneService.saveOrdering(milestoneReOderedList).subscribe(
            (res) => {
                if (res === 1) {
                    this.milestonesReodered.forEach((mst, index) => {
                        let orderIndex = index + 1;
                        let milston = this.milestones.find(
                            (item) => item.milestoneKey === mst.milestoneKey
                        );

                        if (milston) {
                            milston.milestoneOrder = orderIndex;
                        }
                    });

                    this.updateMilestonesToSetOrder();
                    this.updateMilestonesToPrimaryOwner();
                    this.setButtons(true, true);
                    this._toastService.success('Changes were successfully saved!');
                } else {
                    this._toastService.warning('Changes were NOT saved!');
                }
            },
            (error) => {
                throw new Error(error);
            }
        );
    }

    getHeaderStyles() {
        return {
            'text-transform': 'uppercase',
            color: '#223540',
            'font-weight': '600',
        };
    }

    getReSortedArray(event: IMilestoneEvents[]) {
        this.editMilestonesOrder(event);
    }
}
